import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { addressSchema, addressUI } from '../../../definitions';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['secondary-one-info-title--address-home'];
const HINT_TEXT = content['caregiver-address-street-hint'];

const ADDRESS_PROPS = FULL_SCHEMA.definitions.address.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    secondaryOneAddress: addressUI({ streetHint: HINT_TEXT }),
  },
  schema: {
    type: 'object',
    required: ['secondaryOneAddress'],
    properties: {
      secondaryOneAddress: addressSchema({ extend: ADDRESS_PROPS }),
    },
  },
};
